/**
 * Find day entity by provided Date object or "YYYY-MM-DD" format.
 * Hydrate with day type entity.
 */
export default function findDayEntity(selectedDate) {
  // Check input, early return on invalid input.
  if (!selectedDate) {
    return {};
  }
  if (!(selectedDate instanceof Date)) {
    selectedDate = new Date(selectedDate);

    if (selectedDate == 'Invalid Date') {
      return {};
    }
  }
  selectedDate = selectedDate.toISOString().substring(0, 10);

  // If main JS object is missing, early return.
  const unikatumCalendar = window.unikatum_calendar;
  if (typeof unikatumCalendar === 'undefined') {
    return {};
  }

  let dayEntity = {};
  let dayTypeEntity = {};

  // Find day entity.
  unikatumCalendar.days.all.entities.some(day => {
    if (day.fieldDatumTag.value === selectedDate) {
      dayEntity = day;
    }
  })

  // Find day type entity.
  unikatumCalendar.day_types.all.entities.some(dayType => {
    if (dayEntity?.fieldDayType?.targetId && dayType.entityId == dayEntity.fieldDayType.targetId) {
      dayTypeEntity = dayType;
    }
  })

  // Attach day type entity to day entity.
  dayEntity.fieldDayTypeEntity = dayTypeEntity;

  return dayEntity;
}

/**
 * Find event day entity by provided Date object or "YYYY-MM-DD" format.
 */
export function findEventDayEntity(selectedDate) {
  // Check input, early return on invalid input.
  if (!selectedDate) {
    return {};
  }
  if (!(selectedDate instanceof Date)) {
    selectedDate = new Date(selectedDate);

    if (selectedDate == 'Invalid Date') {
      return {};
    }
  }
  selectedDate = selectedDate.toISOString().substring(0, 10);

  // If main JS object is missing, early return.
  const unikatumCalendar = window.unikatum_calendar;
  if (typeof unikatumCalendar === 'undefined') {
    return {};
  }

  let dayEntity = {};

  // Find day entity.
  unikatumCalendar.days.events.entities.some(day => {
    day.fieldDate.some(date => {
      if (date.value === selectedDate) {
        dayEntity = day;
      }
    })
  })

  return dayEntity;
}

/**
 * Find sponsored day entity by provided Date object or "YYYY-MM-DD" format.
 */
export function findSponsoredDayEntity(selectedDate) {
  // Check input, early return on invalid input.
  if (!selectedDate) {
    return {};
  }
  if (!(selectedDate instanceof Date)) {
    selectedDate = new Date(selectedDate);

    if (selectedDate == 'Invalid Date') {
      return {};
    }
  }
  selectedDate = selectedDate.toISOString().substring(0, 10);

  // If main JS object is missing, early return.
  const unikatumCalendar = window.unikatum_calendar;
  if (typeof unikatumCalendar === 'undefined') {
    return {};
  }

  let dayEntity = {};

  // Find day entity.
  unikatumCalendar.days.sponsors.entities.some(day => {
    day.fieldDateFuture.some(date => {
      if (date.value === selectedDate) {
        dayEntity = day;
      }
    })
  })

  return dayEntity;
}

/**
 * Find sponsored month entity by provided Date object or "YYYY-MM-DD" format.
 */
export function findSponsoredMonthEntity(selectedDate) {
  // Check input, early return on invalid input.
  if (!selectedDate) {
    return {};
  }
  if (!(selectedDate instanceof Date)) {
    selectedDate = new Date(selectedDate);

    if (selectedDate == 'Invalid Date') {
      return {};
    }
  }

  // If main JS object is missing, early return.
  const unikatumCalendar = window.unikatum_calendar;
  if (typeof unikatumCalendar === 'undefined') {
    return {};
  }

  let monthEntity = {};

  // Find month entity.
  unikatumCalendar.days.monthSponsors.entities.some(day => {
    let date = new Date(day.fieldDatumPate.value);

    if (date.getMonth() === selectedDate.getMonth()) {
      monthEntity = day;
    }
  })

  return monthEntity;
}

/**
 * Calculate timeslots / opening hours (stored as seconds after midnight).
 * Example: input 50400 returns 14:00.
 */
export function secondsToHoursAndMinutes(seconds) {
  if (!seconds) {
    return '';
  }

  let date = new Date(null);
  date.setSeconds(seconds);

  return date.toISOString().substring(11, 16);
}

/**
 * Return the human-readable opening hours or provided day entity as a string, e.g. "10:00 - 18:00".
 */
export function openingHoursStringFromEntity(dayEntity) {
  let dayType = dayEntity?.fieldDayTypeEntity;
  let label = dayType?.entityLabel;

  if (!dayEntity || !dayType || !label) {
    return '';
  }

  if (label.toLowerCase().includes('geschlossen')) {
    return 'geschlossen';
  }

  let openingHours = dayType?.fieldOpeningHours;
  if (!openingHours) {
    return '';
  }

  let from = openingHours?.from;
  let to = openingHours?.to;

  if (!from || !to) {
    return '';
  }

  return secondsToHoursAndMinutes(from) + ' - ' + secondsToHoursAndMinutes(to);
}
